import { ReactNode } from 'react';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { SearchSectionBoxButtons } from './search-section-box-buttons.component';

interface SearchSectionCtaBoxButtonsProps {
  hasOneCta: boolean;
  children: ReactNode;
}

export const SearchSectionCtaBoxButtons = ({
  hasOneCta,
  children,
}: SearchSectionCtaBoxButtonsProps) => {
  const containerClasses = hasOneCta
    ? 'block xl:hidden p-6 sm:px-16 md:px-6 lg:py-10'
    : 'flex flex-col xl:flex-row gap-3 p-6 sm:px-16 md:px-6 lg:py-10';

  return (
    <SearchSectionBoxButtons
      data-testid={DataTestIdEnum.CITY_CTA_BOX_BUTTONS}
      className={containerClasses}
    >
      {children}
    </SearchSectionBoxButtons>
  );
};
